import { DatalayersMap, defineDirective, IFieldsMapContainerOptions } from "../../omnia"
import { ISoilService } from "../../types"
import { PlanApi } from "../api"
import { MapDependencies } from "../types"
import { Main, MainProps } from "./main/Main"

export class PlanNgWrapper {

    static create() {

        const def = defineDirective(PlanNgWrapper, null)

        def.template = "<div class='material-form'></div>"

        def.scope = {
            "disableUi": "="
        }

        def.link = (scope, element, attrs, ctrl: PlanNgWrapper) => {
            ctrl.link(element)
        }

        return def

    }


    private rootElement: HTMLDivElement

    private disableUi = false

    static $inject = [
        "$scope",
        "OmniaSoilService",
        "OmniaDatalayersDependencies"
    ]

    constructor(
        private readonly $scope: ng.IScope,
        private readonly svc: ISoilService,
        private readonly maps: MapDependencies) {
    }


    $onInit() {
        this.start()
    }

    private link(element: JQLite) {
        this.rootElement = element[0].children[0] as HTMLDivElement
        this.start()
    }


    private start() {

        const { svc, maps, rootElement: root } = this
        if (!(root && svc)) return

        let props: MainProps = undefined

        this.$scope.$watch("vm.svc.stateVersion", (version: number) => {

            const { shell } = maps

            if (!props) {

                const api = new PlanApi(svc)

                const mapFactory = (options?: IFieldsMapContainerOptions) => new DatalayersMap(maps, options)

                props = {

                    api,

                    fieldSvc: svc.fieldSvc,
                    mapFactory,

                    version: 0,

                    shell,

                    disableUi: (disable: boolean) => {
                        this.disableUi = disable
                        this.$scope.$applyAsync()
                    }

                }

            }

            props = { ...props, version }

            const reactElement = React.createElement(Main, props)

            ReactDOM.render(reactElement, root)


        })


    }

    $onDestroy() {

        ReactDOM.unmountComponentAtNode(this.rootElement)

    }
}
